<template>
  <div class="article-create">
    <articles-form
      v-if="!isLoading"
      :data="article"
    />
    <div
      v-else
      class="article-create__loader"
    >
      <loading-icon
        :loading="isLoading"
        loading-class="text-center vertical-middle"
      />
    </div>
  </div>
</template>

<script>
import ArticlesForm from './form/Form'
import {mapActions} from 'vuex'

export default {
  name: 'CreateArticle',

  components: {
    ArticlesForm,
  },

  data () {
    return {
      article: {
        action: null,
        channel: null,
        channel_id: null,
        channel_content_type: {},
        content_type: null,
        content_type_id: null,
        is_pro_exclusive: true,
        analysts: !this.$login.getUser().analyst ? [] : [this.$login.getUser().analyst],
        teaser_text: null,
        email_body: null,
        tags: [],
        tickers: [],
        article_layout: {id: 1},
        companies: [],
        alert_top_right: null,
        latest_revision: null,
      },
      channelId: this.$login.channelScopeId(),
      isLoading: true,
    }
  },

  created () {
    this.getData()
  },

  methods: {
    ...mapActions('channels', [
      'findChannel'
    ]),
    async getData () {
      if (this.channelId) {
        const channel = await this.findChannel(this.channelId)
        this.article.channel = channel
        this.article.channel_id = this.channelId
      }

      this.isLoading = false
    },
  },
}
</script>

<style lang="scss">
.article-create {
  &-main {
    margin-top: 2rem;
  }

  &-navigation {
    margin-top: 2rem;
    padding: 1.5rem 0;
    border-top: 1px solid $border-color;
  }

  &__loader {
    height: calc(100vh - 200px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

